
const STORAGE_KEY = "homepageModuleOrigin";

export const markHomepageOrigin = (module) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, module);
  } catch (error) {
    
    console.error("Nao foi possivel marcar a origem do acesso:", error);
  }
};


export const consumeHomepageOrigin = (module) => {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) !== module) {
      return false;
    }

    sessionStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (error) {
    console.error("Nao foi possivel ler a origem do acesso:", error);
    return false;
  }
};
